<template>
  <div class="laypanel">
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="订单日期:">
            <el-date-picker
              v-model="byorderdate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="querfxorder">查询订单</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="fxorderdata"
        ref="multipleTable">
        <el-table-column
          prop="fxusernick"
          label="分销员昵称">
        </el-table-column>
        <el-table-column
          prop="fxusercontact"
          label="联系方式">
        </el-table-column>
        <el-table-column
          label="操作"
          width="80px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看订单详情" placement="top-start">
              <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seefxinfo(scope.$index, fxorderdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog :title="fxfzstate" :visible.sync="fxpanelvisible">
      <div class="showpcinfo">
        <el-form >
          <el-row class="querypanel">
            <el-col :span="24">
              <el-table
                stripe
                show-summary
                :summary-method="getSummaries"
                :data="subonefxorderdata"
                ref="multipleTable">
                <el-table-column
                  prop="orderno"
                  width = "200px"
                  label="订单号">
                </el-table-column>
                <el-table-column
                  prop="tradeno.String"
                  width = "200px"
                  label="支付单号">
                </el-table-column>
                <el-table-column
                  prop="countprice"
                  width = "200px"
                  label="金额">
                </el-table-column>
                <el-table-column
                  prop="name.String"
                  label="用户昵称">
                </el-table-column>
                <el-table-column
                  prop="phone.String"
                  label="联系方式">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看订单详情" placement="top-start">
                      <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seesuborder(scope.$index, subonefxorderdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12" style="margin-top: 20px;">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="下游分销等级:" style="margin-left: 20px;">
                  <el-input disabled v-model="fxonelevel" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12" style="margin-top: 20px;">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="分润比率(%):" style="margin-left: 20px;">
                  <el-input disabled v-model="fxponepersent" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="购买总额:" style="margin-left: 20px;">
                  <el-input disabled v-model="fxonebuycount" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="分成:" style="margin-left: 20px;">
                  <el-input disabled v-model="fxonefc" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row class="querypanel" :hidden="ifhidden">
            <el-col :span="24">
              <el-table
                stripe
                show-summary
                :summary-method="getSummaries"
                :data="subtwofxorderdata"
                ref="multipleTable">
                <el-table-column
                  prop="orderno"
                  width = "200px"
                  label="订单号">
                </el-table-column>
                <el-table-column
                  prop="tradeno.String"
                  width = "200px"
                  label="支付单号">
                </el-table-column>
                <el-table-column
                  prop="countprice"
                  width = "200px"
                  label="金额">
                </el-table-column>
                <el-table-column
                  prop="name.String"
                  label="购买用户">
                </el-table-column>
                <el-table-column
                  prop="phone.String"
                  label="联系方式">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看订单详情" placement="top-start">
                      <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seesuborder(scope.$index, subtwofxorderdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12" style="margin-top: 20px;">
              <el-form   label-width="120px" label-position="left" >
                <el-form-item label="下游分销等级:" style="margin-left: 20px;">
                  <el-input disabled v-model="fxtwolevel" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12" style="margin-top: 20px;">
              <el-form   label-width="120px" label-position="left" >
                <el-form-item label="分润比率(%):" style="margin-left: 20px;">
                  <el-input disabled v-model="fxtwopersent" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="购买总额:" style="margin-left: 20px;">
                  <el-input disabled v-model="fxtwobuycount" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="分成:" style="margin-left: 20px;">
                  <el-input disabled v-model="fxtwofc" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>

          <el-row class="querypanel">
            <el-col :span="24">
              <el-table
                stripe
                show-summary
                :data="yfddata"
                ref="multipleTable">
                <el-table-column
                  prop="fxuserid"
                  label="ID">
                </el-table-column>
                <el-table-column
                  prop="jsprice"
                  width = "200px"
                  label="结算金额">
                </el-table-column>
                <el-table-column
                  prop="jsstate"
                  label="结算状态">
                </el-table-column>
                <el-table-column
                  prop="jsstart"
                  width="200"
                  label="结算周期起点">
                </el-table-column>
                <el-table-column
                  prop="jsend"
                  width="200"
                  label="结算周期终点">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="废除预结算订单" placement="top-start">
                      <i class="fa fa-trash-o fa-lg ciicon curpointer" v-on:click="delyjsinfo(scope.$index, yfddata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-button style="margin-top: 20px" @click="makefxorder">生成预付单</el-button>
          <el-button style="margin-top: 20px" @click="fxyfk">确认付款</el-button>
        </el-form>
      </div>
      <div class="showpcinfo">
      </div>
    </el-dialog>
    <el-dialog title="订单详情" :visible.sync="orderdetailvisible">
      <div class="showpcinfo">
        <el-table
          stripe
          show-summary
          :data="orderdetaildata"
          ref="multipleTable">
          <el-table-column
            prop="name.String"
            width = "280px"
            label="商品名称">
          </el-table-column>
          <el-table-column
            prop="gspecname.String"
            label="规格">
          </el-table-column>
          <el-table-column
            prop="price"
            label="单价">
          </el-table-column>
          <el-table-column
            prop="count"
            label="数量">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'FxOrder',
  data () {
    return {
      byorderdate: '',
      fxorderdata: [],
      fxpanelvisible: false,
      fxinfolist: [],
      subonefxorderdata: [],
      subtwofxorderdata: [],
      clorderdata: [],
      yfddata: [],
      orderdetaildata: [],
      fxtwopersent: '',
      orderdetailvisible: false,
      fxtwobuycount: '',
      fxtwofc: '',
      fxtwolevel: '',
      fxonefc: '',
      fxonebuycount: '',
      ifhidden: false,
      fxponepersent: '',
      fxonelevel: '',
      selectuserid: '',
      fxfzstate: '',
      fxorderid: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      var qstr = 'cusid = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/gbsscp',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            if (res.data.data !== '[]') {
              var qpercent = JSON.parse(res.data.data)
              for (var i = 0; i < qpercent.length; i++) {
                if (qpercent[i].level === 1) {
                  that.fxonelevel = qpercent[i].level
                  that.fxponepersent = qpercent[i].levelpercent
                } else if (qpercent[i].level === 2) {
                  that.fxtwolevel = qpercent[i].level
                  that.fxtwopersent = qpercent[i].levelpercent
                }
              }
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    seesuborder (index, data) {
      var ddata = data[index]
      this.orderdetailvisible = true

      var qstr = "order_no ='" + ddata.orderno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/god',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.orderdetaildata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getSummaries (param) {
      console.log('sum param')
      console.log(param)
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        if (index === 2) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' 元'
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      return sums
    },
    querfxorder () {
      var cusidlist = []
      this.fxinfolist = []
      var qstr = 'cusid = ' + this.khid + ' and state=1'
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/gssr',
        method: 'post',
        data: {
          whereinfo: {'String': qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              var tdata = JSON.parse(res.data.data)
              for (var i = 0; i < tdata.length; i++) {
                var subtdata = tdata[i]
                cusidlist.push(subtdata.userid)
                that.fxinfolist.push(subtdata)
              }
              console.log(cusidlist)
              var qstr = 'buy_cus_id in (' + cusidlist + ')'
              if (that.byorderdate !== null && that.byorderdate !== '') {
                qstr = qstr + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/gfxoi',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true},
                  groupinfo: {String: ' group by buy_cus_id', Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.fxorderdata = JSON.parse(res.data.data)
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seefxinfo (index, data) {
      this.fxpanelvisible = true
      var qddata = data[index]
      this.selectuserid = qddata.fxuserid
      var dataindex = this.fxinfolist.findIndex(d => d.userid === qddata.fxuserid)
      console.log(this.fxinfolist[dataindex].parentid)
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/gtssrex',
        method: 'post',
        data: {
          userid: parseInt(this.fxinfolist[dataindex].userid),
          cusid: parseInt(this.khid)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            var qddata = JSON.parse(res.data.data)
            console.log(qddata)
            if (res.data.data !== '[]' && qddata[0].haschild > 0) {
              var cusidonelist = []
              cusidonelist.push(that.selectuserid)
              var cusidtwolist = []
              var cusidthreelist = []
              var tdata = JSON.parse(res.data.data)
              for (var i = 0; i < tdata.length; i++) {
                var subtdata = tdata[i]
                cusidtwolist.push(subtdata.userid)
                console.log(subtdata)
                if (subtdata.haschild > 0) {
                  for (var j = 0; j < subtdata.Children.length; j++) {
                    var subsubdata = subtdata.Children[j]
                    cusidthreelist.push(subsubdata.userid)
                  }
                }
              }
              console.log('一级分销')
              console.log(cusidonelist)
              console.log('二级分销')
              console.log(cusidtwolist)
              console.log('三级分销')
              console.log(cusidthreelist)
              var qstr = 'cus_id in (' + cusidonelist + ') and state_id > 1 and state_id < 6'
              console.log(qstr)
              if (that.byorderdate !== null && that.byorderdate !== '') {
                qstr = qstr + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/goi',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    if (res.data.data !== '[]') {
                      console.log('一级分销数据')
                      console.log(JSON.parse(res.data.data))
                      that.subonefxorderdata = JSON.parse(res.data.data)
                      var counttmp = 0
                      for (var x = 0; x < that.subonefxorderdata.length; x++) {
                        counttmp = counttmp + that.subonefxorderdata[x].countprice
                      }
                      that.fxonebuycount = counttmp
                      that.fxonefc = that.fxonebuycount * (parseInt(that.fxponepersent) / 100)
                    } else {
                      that.fxonebuycount = 0
                      that.fxonefc = 0
                    }
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
              if (cusidtwolist.length > 0) {
                that.ifhidden = false
                var qstr1 = 'cus_id in (' + cusidtwolist + ')  and state_id > 1 and state_id < 6'
                if (that.byorderdate !== null && that.byorderdate !== '') {
                  qstr1 = qstr1 + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
                }
                that.$http({
                  url: 'https://api.sqnetsoft.cn/order/goi',
                  method: 'post',
                  data: {
                    whereinfo: {String: qstr1, Valid: true},
                    groupinfo: {String: ' group by buy_cus_id', Valid: true}
                  },
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    if (res.data.success) {
                      if (res.data.data !== '[]') {
                        console.log('二级分销数据')
                        console.log(JSON.parse(res.data.data))
                        that.subtwofxorderdata = JSON.parse(res.data.data)
                        var counttmp = 0
                        for (var x = 0; x < that.subtwofxorderdata.length; x++) {
                          counttmp = counttmp + that.subtwofxorderdata[x].countprice
                        }
                        that.fxtwobuycount = counttmp
                        that.fxtwofc = that.fxtwobuycount * (parseInt(that.fxtwopersent) / 100)
                      } else {
                        that.fxtwobuycount = 0
                        that.fxtwofc = 0
                      }
                    }
                  })
                  .catch(function (error) {
                    console.log('error' + error)
                  })
              } else {
                that.subtwofxorderdata = []
                that.ifhidden = true
              }
            } else {
              console.log('没有找到子集')
              var cusidonelist3 = []
              that.ifhidden = true
              cusidonelist3.push(that.selectuserid)
              console.log(cusidonelist3)
              var qstr9 = 'cus_id in (' + cusidonelist3 + ')  and state_id > 1 and state_id < 6'
              console.log(qstr9)
              if (that.byorderdate !== null && that.byorderdate !== '') {
                qstr9 = qstr9 + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/goi',
                method: 'post',
                data: {
                  whereinfo: {String: qstr9, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.subonefxorderdata = JSON.parse(res.data.data)
                    if (res.data.data !== '[]') {
                      var counttmp = 0
                      for (var x = 0; x < that.subonefxorderdata.length; x++) {
                        counttmp = counttmp + that.subonefxorderdata[x].countprice
                      }
                      that.fxonebuycount = counttmp
                      that.fxonefc = that.fxonebuycount * (parseInt(that.fxponepersent) / 100)
                    } else {
                      that.fxonebuycount = 0
                      that.fxonefc = 0
                    }
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var qstr1 = 'fxuserid = ' + qddata.fxuserid
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/gbsss',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              console.log('分销分账信息')
              var qddata = JSON.parse(res.data.data)
              console.log(qddata)
              that.fxorderid = qddata[0].id.Int64
              console.log(qddata[0].jsstate)
              if (qddata[0].jsstate === 0) {
                that.fxfzstate = '当前状态：已生成分销分账订单，未付款'
              } else {
                that.fxfzstate = '当前状态：分销分账订单已付款'
              }
              console.log(res.data.data)
            } else {
              that.fxorderid = 0
              that.fxfzstate = '当前状态：未生成分销分账订单，未付款'
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      that.clorderdata = []
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/gtssrex',
        method: 'post',
        data: {
          userid: parseInt(this.fxinfolist[dataindex].userid),
          cusid: parseInt(this.khid)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('查询分销人员表')
          console.log(res)
          if (res.data.success) {
            var cusidonelist = []
            cusidonelist.push(that.selectuserid)
            var qddata = JSON.parse(res.data.data)
            if (res.data.data !== '[]' && qddata[0].haschild > 0) {
              console.log('找到子集')
              var cusidtwolist = []
              var cusidthreelist = []
              var tdata = JSON.parse(res.data.data)
              for (var i = 0; i < tdata.length; i++) {
                var subtdata = tdata[i]
                cusidtwolist.push(subtdata.userid)
                console.log(subtdata)
                if (subtdata.haschild > 0) {
                  for (var j = 0; j < subtdata.Children.length; j++) {
                    var subsubdata = subtdata.Children[j]
                    console.log(subsubdata)
                    cusidthreelist.push(subsubdata.userid)
                  }
                }
              }
            }
            console.log(cusidonelist)
            var qstr = 'cus_id in (' + cusidonelist + ')  and state_id > 1 and state_id < 6'
            if (that.byorderdate !== null && that.byorderdate !== '') {
              qstr = qstr + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/order/goi',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  var oneorderstmp = JSON.parse(res.data.data)
                  if (res.data.data !== '[]') {
                    for (var x = 0; x < oneorderstmp.length; x++) {
                      console.log('首次填充数据')
                      that.clorderdata.push(oneorderstmp[x].orderno)
                    }
                    console.log(that.clorderdata)
                    console.log('cusidtwolist')
                    console.log(cusidtwolist)
                    if (cusidtwolist.length > 0) {
                      var qstr1 = 'cus_id in (' + cusidtwolist + ')  and state_id > 1 and state_id < 6'
                      if (that.byorderdate !== null && that.byorderdate !== '') {
                        qstr1 = qstr1 + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
                      }
                      that.$http({
                        url: 'https://api.sqnetsoft.cn/order/goi',
                        method: 'post',
                        data: {
                          whereinfo: {String: qstr1, Valid: true}
                        },
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      })
                        .then(function (res) {
                          if (res.data.success) {
                            console.log(JSON.parse(res.data.data))
                            var twoorderstmp = JSON.parse(res.data.data)
                            if (res.data.data !== '[]') {
                              for (var x = 0; x < twoorderstmp.length; x++) {
                                that.clorderdata.push(twoorderstmp[x].orderno)
                              }
                            }
                          }
                        })
                        .catch(function (error) {
                          console.log('error' + error)
                        })
                    }
                  }
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      /*****/
      var qyfkstr = 'fxuserid = ' + qddata.fxuserid
      console.log(qyfkstr)
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/gbsss',
        method: 'post',
        data: {
          whereinfo: {String: qyfkstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('分销数据')
            console.log(JSON.parse(res.data.data))
            that.yfddata = JSON.parse(res.data.data)
            if (res.data.data !== '[]') {
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    makefxorder () {
      /// 变更所有结算的订单状态
      console.log('订单列表')
      var fccountprice = that.fxonefc + that.fxtwofc
      if (that.byorderdate !== null && that.byorderdate !== '') {
        var idata = {
          fxuserid: parseInt(this.selectuserid),
          jsprice: fccountprice.toString(),
          jsstate: parseInt(0),
          jsstart: that.byorderdate[0] + ' 00:00:00',
          jsend: that.byorderdate[1] + ' 23:59:59',
          jsdate: '',
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/subsale/absss',
          method: 'post',
          data: idata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.fxpanelvisible = false
              that.$message({
                type: 'success',
                message: '分销分账订单生成完毕!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'info',
          message: '请选择结算日期!'
        })
      }
    },
    fxyfk () {
      var that = this
      console.log(that.clorderdata)
      if (that.fxorderid === 0) {
        that.$message({
          type: 'info',
          message: '请先生成分账订单!'
        })
      } else {
        var timestamp1 = Date.parse(new Date())
        var qstr = 'id = ' + that.fxorderid
        var upstr = 'jsstate = 1,jsdate=\'' + timestamp1 + '\''
        that.$http({
          url: 'https://api.sqnetsoft.cn/subsale/ubsss',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: upstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              var findqstr = ' FIND_IN_SET(order_no,"' + that.clorderdata + '")'
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/upboi',
                method: 'post',
                data: {
                  whereinfo: {String: findqstr, Valid: true},
                  fieldparams: { String: ' state_id=6', Valid: true }
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    that.$message({
                      type: 'success',
                      message: '分销分账状态已更新!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
              if (res.data.data !== '[]') {
                that.$message({
                  type: 'success',
                  message: '分销分账状态已更新！'
                })
                that.fxpanelvisible = false
              }
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    delyjsinfo (index, data) {
      var sqlstr = 'id = ' + data[index].id.Int64
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/dbsss',
        method: 'post',
        data: {
          whereinfo: {String: sqlstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var qyfkstr = 'fxuserid = ' + data[index].fxuserid
            that.$http({
              url: 'https://api.sqnetsoft.cn/subsale/gbsss',
              method: 'post',
              data: {
                whereinfo: {String: qyfkstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                console.log(res)
                console.log(JSON.parse(res.data.data))
                that.yfddata = JSON.parse(res.data.data)
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/finance/FxFZ.vue